<template>
  <div v-loading="loading" style="min-height: 400px">
    <div class="rj-page-card__title">
      基本信息
    </div>
    <div class="rj-row">
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            电汇编号：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.telegraphicTransferNum }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入公司：
          </div>
          <div>{{ telegraphicTransfer.accountCompany }}</div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            币种：
          </div>
          <div class="rj-baseinfo__item">
            人民币
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            代理名称：
          </div>
          <div v-if="telegraphicTransfer.newImportCompany" class="rj-baseinfo__item">
            {{ telegraphicTransfer.newImportCompany }}
          </div>
          <div v-else class="rj-baseinfo__item">
            {{ telegraphicTransfer.importCompany }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇款日期：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.remittanceDate }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇款金额：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.remittanceAmount }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入账户：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.account }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            状态：
          </div>
          <div class="rj-baseinfo__item">
            已到账
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            备注：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.summary }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            可用余额：
          </div>
          <div class="rj-baseinfo__item">
            {{ telegraphicTransfer.unusedAmount }}
          </div>
        </div>
      </div>
    </div>
    <div class="rj-page-card__title" style="margin-top: 15px">
      电汇所指订单列表
    </div>
    <!-- <div>金额小计：<span class="money">{{ totalAssignAmount }}元</span></div> -->
    <el-table :data="tableData" border style="width: 100%;margin-top: 10px" height="180">
      <el-table-column type="index" width="60" label="序号" align="left" />
      <el-table-column prop="contractNum" label="锐捷电子商务合同编号" align="left" />
      <el-table-column prop="erpOrderNum" label="分配订单号" align="left" />
      <el-table-column prop="orderNetSale" label="订单总金额" align="right" header-align="left" />
      <el-table-column prop="assignAmount" label="本次分配金额" align="right" header-align="left" />
      <el-table-column prop="assignDate" label="分配日期" align="left" width="140px" />
    </el-table>
  </div>
</template>

<script>
import { selectConfirmDetailByTeleNum, confirmApplyForRefund } from '@/API/index';
import { MathAdd } from '@/libs/util';
import eventBus from '@/libs/eventBus';
export default {
  name: 'FinanceremittanceInfoBox',
  data () {
    return {
      tableData: [],
      loading: false,
      telegraphicTransfer: [],
      totalAssignAmount: 0
    };
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {},
  computed: {
    totalAccount () {
      let num = 0;
      this.tableData.forEach((item) => {
        if (item.assignAmount) {
          num = MathAdd(num, item.assignAmount);
        }
      });
      // num = num.toFixed(2);
      return num;
    }
  },
  methods: {
    selectDetail () {
      selectConfirmDetailByTeleNum(this.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.contractAssignGroup;
          this.telegraphicTransfer = json.data.telegraphicTransfer;
          this.totalAssignAmount = json.data.totalAssignAmount;
          this.dId = json.data.telegraphicTransfer.id;
        }
      }).catch((res) => {

      });
    },
    confirmApplyForRefund () {
      confirmApplyForRefund(this.id, this.dId, 'Y').then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify.success('确认退款成功');
          this.$emit('close');
        }
      }).catch((res) => {

      });
    }
  },
  mounted () {
    this.selectDetail();
    eventBus.$on('confirmApply', () => {
      this.confirmApplyForRefund();
    });
  },
  destroyed () {
    eventBus.$off('confirmApply');
  }
};
</script>

<style lang="scss">
  .money{
    color: #f60;
  }
</style>
